import Phaser from 'phaser';
import { ANIM_KEYS, TEXTURE_KEYS } from './assetKeys';

export class AnimationRegistry {
  static registerAll(scene: Phaser.Scene): void {
    if (!scene.anims.exists(ANIM_KEYS.PLAYER_IDLE)) {
      scene.anims.create({
        key: ANIM_KEYS.PLAYER_IDLE,
        frames: [
          { key: TEXTURE_KEYS.PLAYER_IDLE_0 },
          { key: TEXTURE_KEYS.PLAYER_IDLE_1 },
        ],
        frameRate: 2,
        repeat: -1,
      });
    }

    if (!scene.anims.exists(ANIM_KEYS.PLAYER_WALK)) {
      scene.anims.create({
        key: ANIM_KEYS.PLAYER_WALK,
        frames: [
          { key: TEXTURE_KEYS.PLAYER_WALK_0 },
          { key: TEXTURE_KEYS.PLAYER_WALK_1 },
          { key: TEXTURE_KEYS.PLAYER_WALK_2 },
          { key: TEXTURE_KEYS.PLAYER_WALK_3 },
        ],
        frameRate: 10,
        repeat: -1,
      });
    }
  }
}
